import { RichText } from 'prismic-reactjs';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { IPrismicGiftItemBannerContent } from '@monofront/types';

const GiftItemBannerContent: React.FC<{
  content: IPrismicGiftItemBannerContent;
}> = ({ content }) => (
  <>
    <div className="announcement">
      {content.icon && (
        <ResponsiveImage
          src={content.icon.url}
          alt={content.icon.alt}
          width={20}
          height={20}
        />
      )}
      <div className="mobile-announcement mobile-only">
        <RichText render={content.mobile_text} />
      </div>
      <div className="desktop-announcement desktop-only">
        <RichText render={content.desktop_text} />
      </div>
    </div>
    <style jsx>{`
      .announcement {
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .mobile-announcement,
      .desktop-announcement {
        margin-left: var(--space-1);
      }

      .mobile-announcement > :global(p) {
        line-height: 15px;
        font-size: var(--font-size-1);
      }

      .text-subscription {
        margin-right: var(--space-2);
      }

      @media (max-width: 800px) {
        .text-subscription {
          font-size: var(--font-size-1);
        }
      }
    `}</style>
  </>
);

export default GiftItemBannerContent;
